import { Vector2CanvasNormalized, Vector2ElementNormalized } from '@typings/vectors';

export function workaroundCanvasRatio(canvasRatio?: { x: number; y: number }): Vector2CanvasNormalized {
  const multiplier = canvasRatio;
  return [Math.max(multiplier?.x ?? 1, 1), Math.max(multiplier?.y ?? 1, 1)] as Vector2CanvasNormalized;
}

export function workaroundPivot(pivot?: { x: number; y: number }): Vector2ElementNormalized {
  return [
    pivot?.x ?? 0.5,
    1 - (pivot?.y ?? 0.5), // Invert Y axis, because in LP the origin is at the bottom left
  ] as Vector2ElementNormalized;
}
